class NumberUtils {
    public static parseInteger(value: string): number {
        return parseInt(value, 10);
    }
}

export { NumberUtils };
